import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as types from './actionTypes';
import Swal from 'sweetalert2';
import { post } from 'helpers/api_helper';

// 1. Fetch Timesheet Mode
function* fetchTimesheetModeSaga(action) {
  try {
    const {unit_id} = action.payload;
    const formData = new FormData()
    formData.append("unit_id",unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_MODE, formData);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet mode!');
    yield put({ type: types.FETCH_TIMESHEET_MODE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_MODE_FAILURE, payload: error.message });
  }
}

// 2. Fetch Timesheet Project
function* fetchTimesheetProjectSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_PROJECT, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet project!');
    yield put({ type: types.FETCH_TIMESHEET_PROJECT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_PROJECT_FAILURE, payload: error.message });
  }
}

// 3. Fetch Timesheet Module
function* fetchTimesheetModuleSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_MODULE, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet module!');
    yield put({ type: types.FETCH_TIMESHEET_MODULE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_MODULE_FAILURE, payload: error.message });
  }
}

// 4. Fetch Timesheet Task
function* fetchTimesheetTaskSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_TASK, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet task!');
    yield put({ type: types.FETCH_TIMESHEET_TASK_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_TASK_FAILURE, payload: error.message });
  }
}

// 5. Fetch Timesheet Task Type
function* fetchTimesheetTaskTypeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_TASKTYPE, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet task type!');
    yield put({ type: types.FETCH_TIMESHEET_TASKTYPE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_TASKTYPE_FAILURE, payload: error.message });
  }
}

function* fetchTimesheetNonProjectTaskTypeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_NON_PROJECT_TASKTYPE, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet task type!');
    yield put({ type: types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_FAILURE, payload: error.message });
  }
}

// 6. Fetch Timesheet List
function* fetchTimesheetListSaga(action) {
  // try {
  //   const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_LIST, action.payload);
  //   if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet list!');
  //   yield put({ type: types.FETCH_TIMESHEET_LIST_SUCCESS, payload: response.data });
  // } catch (error) {
  //   yield put({ type: types.FETCH_TIMESHEET_LIST_FAILURE, payload: error.message });
  // }

  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_LIST, action.payload);
    // Treat empty data as SUCCESS
    if (response.status === "success" || response.status === "failure") {
      yield put({
        type: types.FETCH_TIMESHEET_LIST_SUCCESS,
        payload: response.data || []
      });
    } else {
      throw new Error(response?.message || "Failed to fetch timesheet list!");
    }
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_LIST_FAILURE, payload: error.message });
  }

}

// 7. Fetch Month-wise Timesheet Details
function* fetchTimesheetMonthDetailsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_MONTH_DETAILS, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch month-wise details!');
    yield put({ type: types.FETCH_TIMESHEET_MONTH_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_MONTH_DETAILS_FAILURE, payload: error.message });
  }
}

// 8. Save Timesheet Details
function* saveTimesheetDetailsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_TIMESHEET, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to save timesheet!');
    yield put({ type: types.SAVE_TIMESHEET_DETAILS_SUCCESS, payload: response });
    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    yield put({ type: types.SAVE_TIMESHEET_DETAILS_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

// 9. Change Timesheet Task Status
function* changeTimesheetTaskStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_TIMESHEET_TASK_STATUS, action.payload);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to change task status!');
    yield put({ type: types.CHANGE_TIMESHEET_TASK_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    yield put({ type: types.CHANGE_TIMESHEET_TASK_STATUS_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

function* fetchTimesheetClientSaga(action) {
  try {
    const {unit_id,create_by} = action.payload;
    const formData = new FormData()
    formData.append("unit_id",unit_id);
    formData.append("emp_id",create_by);
    const response = yield call(post, process.env.REACT_APP_FETCH_TIMESHEET_CLIENT, formData);
    if (response.status !== 'success') throw new Error(response?.message || 'Failed to fetch timesheet clients!');
    yield put({ type: types.FETCH_TIMESHEET_CLIENT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_TIMESHEET_CLIENT_FAILURE, payload: error.message });
  }
}

// Watcher
export default function* timesheetSaga() {
  yield all([
    takeLatest(types.FETCH_TIMESHEET_MODE_REQUEST, fetchTimesheetModeSaga),
    takeLatest(types.FETCH_TIMESHEET_PROJECT_REQUEST, fetchTimesheetProjectSaga),
    takeLatest(types.FETCH_TIMESHEET_MODULE_REQUEST, fetchTimesheetModuleSaga),
    takeLatest(types.FETCH_TIMESHEET_TASK_REQUEST, fetchTimesheetTaskSaga),
    takeLatest(types.FETCH_TIMESHEET_TASKTYPE_REQUEST, fetchTimesheetTaskTypeSaga),
    takeLatest(types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_REQUEST, fetchTimesheetNonProjectTaskTypeSaga),
    takeLatest(types.FETCH_TIMESHEET_LIST_REQUEST, fetchTimesheetListSaga),
    takeLatest(types.FETCH_TIMESHEET_MONTH_DETAILS_REQUEST, fetchTimesheetMonthDetailsSaga),
    takeLatest(types.SAVE_TIMESHEET_DETAILS_REQUEST, saveTimesheetDetailsSaga),
    takeLatest(types.CHANGE_TIMESHEET_TASK_STATUS_REQUEST, changeTimesheetTaskStatusSaga),
    takeLatest(types.FETCH_TIMESHEET_CLIENT_REQUEST, fetchTimesheetClientSaga),
  ]);
}
